/** Sidebar navigation per role: [path segment, label, icon]. A one-item array is a group heading. */
export const NAV = {
  student: [
    ['dashboard', 'Dashboard', 'home'], ['learn', 'Courses', 'book'], ['classes', 'Live classes', 'play'], ['tests', 'Tests', 'clip'], ['recordings', 'Recordings', 'cam'],
    ['progress', 'My progress', 'chart'], ['opportunities', 'Opportunities', 'brief'], ['network', 'Network', 'users'], ['messages', 'Messages', 'chat'],
    ['billing', 'Billing', 'wallet'], ['profile', 'Profile', 'user'],
  ],
  professional: [
    ['dashboard', 'Dashboard', 'home'], ['coaching', 'Coaching', 'play'], ['requirements', 'Requirements', 'clip'], ['projects', 'Projects', 'layers'],
    ['services', 'Services', 'grid'], ['earnings', 'Earnings', 'wallet'], ['network', 'Network', 'users'], ['messages', 'Messages', 'chat'], ['profile', 'My profile', 'user'],
  ],
  company: [
    ['dashboard', 'Dashboard', 'home'], ['requirements', 'Requirements', 'clip'], ['talent', 'Find talent', 'target'], ['shortlisted', 'Hiring pipeline', 'users'],
    ['projects', 'Projects', 'layers'], ['messages', 'Messages', 'chat'], ['profile', 'Company profile', 'build'],
  ],
  startup: [
    ['dashboard', 'Dashboard', 'home'], ['requirements', 'Requirements', 'clip'], ['people', 'Find people', 'target'], ['cofounder', 'Co-founders', 'rocket'],
    ['projects', 'Projects', 'layers'], ['network', 'Network', 'users'], ['messages', 'Messages', 'chat'], ['profile', 'Startup profile', 'build'],
  ],
  admin: [
    ['Platform'], ['overview', 'Overview', 'home'], ['analytics', 'Analytics', 'trend'], ['reports', 'Reports', 'file'],
    ['People'], ['users', 'All users', 'users'],
    ['Learning'], ['courses', 'Courses', 'book'], ['batches', 'Batches', 'cal'], ['coupons', 'Coupons', 'rupee'], ['assessments', 'Assessments', 'clip'], ['tests', 'Live tests', 'clip'], ['demos', 'Free demos', 'play'], ['resume-requests', 'Resume requests', 'file'],
    ['Matching'], ['requirements', 'Requirements', 'target'], ['opportunities', 'Opportunities', 'spark'], ['introductions', 'Introductions', 'link'],
    ['Trust'], ['safety', 'Safety', 'shield'], ['enquiries', 'Enquiries', 'chat'], ['payments', 'Payments', 'rupee'], ['deposits', 'Deposits', 'wallet'], ['payouts', 'Payouts', 'wallet'],
    ['System'], ['settings', 'Settings', 'gear'],
  ],
};

export const PUBLIC_LINKS = [
  ['/', 'Home'], ['/students', 'Students / Job seekers'], ['/freelancers', 'Freelancers'], ['/companies', 'Companies'], ['/startups', 'Startups'],
  ['/requirements', 'Post requirement'], ['/about', 'About'],
];

export const isHeading = (item) => item.length === 1;
